import { displayNewMessageForm } from './DisplayNewMessageFormAdapter';
import { displayReplyForm } from './DisplayReplyFormAdapter';
import { displayMessageForm } from '../CommonAdapters/DisplayMessageFormAdapter';
import { isReadAddinPinned as isAddinPinned } from '../CommonAdapters/IsAddinPinnedAdapter';
import { getReadItemId as getItemId } from '../CommonAdapters/ItemIdAdapter';
import { ExtensibilityModeEnum } from 'owa-addins-types';
import { addNotificationMessage, removeNotificationMessage, getNotificationMessageIds, } from '../NotificationMessageAdapters/ReadNotificationMessageAdapter';
import { findInlineComposeViewState } from 'owa-mail-compose-store';
var getItem = function (item) { return function () {
    return item;
}; };
var isItemSelected = function (viewState) { return function () {
    return viewState.isConversationItemPart ? viewState.isSelected : true;
}; };
var isInlineComposeOpen = function (viewState, item) { return function () {
    var conversationId = viewState.isConversationItemPart && item.ConversationId ? item.ConversationId.Id : null;
    return !!findInlineComposeViewState(conversationId);
}; };
export default function createMailReadAdapter(item, viewState) {
    return {
        getItem: getItem(item),
        getItemId: getItemId(item),
        addNotificationMessage: addNotificationMessage(viewState),
        removeNotificationMessage: removeNotificationMessage(viewState),
        getNotificationMessageIds: getNotificationMessageIds(viewState),
        mode: ExtensibilityModeEnum.MessageRead,
        displayMessageForm: displayMessageForm,
        displayNewMessageForm: displayNewMessageForm,
        displayReplyForm: displayReplyForm,
        isAddinPinned: isAddinPinned,
        isItemSelected: isItemSelected(viewState),
        isInlineComposeOpen: isInlineComposeOpen(viewState, item),
    };
}
//# sourceMappingURL=ReadAdapterCreator.js.map